import { render, staticRenderFns } from "./CryptoTshirt.vue?vue&type=template&id=ffcaa9e2"
import script from "./CryptoTshirt.vue?vue&type=script&lang=js"
export * from "./CryptoTshirt.vue?vue&type=script&lang=js"
import style0 from "./CryptoTshirt.vue?vue&type=style&index=0&id=ffcaa9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports